'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _oembed = require('redux/modules/oembed');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    oembed: state.oembed.oembed,
    error: state.oembed.error
  };
}, { search: _oembed.search, removeOEmbed: _oembed.remove }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(VideoBox, _Component);

  function VideoBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VideoBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VideoBox.__proto__ || (0, _getPrototypeOf2.default)(VideoBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: '',
      isPopoverOpen: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VideoBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.searchVideo(this.props.video_url);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.searchVideo(nextProps.video_url);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeOEmbed();
      document.body.removeEventListener('keydown', this.handleKeyDown.bind(this), false);
    }
  }, {
    key: 'searchVideo',
    value: function searchVideo(videoUrl) {
      var _this2 = this;

      var state = this.state;

      if (videoUrl && videoUrl !== this.state.value) {
        state = (0, _reactAddonsUpdate2.default)(state, {
          $merge: {
            value: videoUrl
          }
        });

        this.setState(state, function () {
          if (videoUrl && String(videoUrl).length) {
            _this2.props.search(videoUrl);
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({ value: event.target.value });
    }
  }, {
    key: 'handleEnteredPopover',
    value: function handleEnteredPopover() {
      document.body.addEventListener('keydown', this.handleKeyDown.bind(this), false);
      document.getElementById('video_url').focus();
      this.setState({ isPopoverOpen: true });
    }
  }, {
    key: 'handleExitPopover',
    value: function handleExitPopover() {
      var value = this.state.value; // eslint-disable-line no-shadow

      var _props = this.props,
          search = _props.search,
          onChange = _props.onChange; // eslint-disable-line no-shadow

      var url = String(value);

      // valide string is URL ?
      if (url.length) {
        search(url).then(function (res) {
          if (res.type === 'caligram/oembed/SEARCH_SUCCESS') {
            onChange(url, res.result);
          }
        });
      }
    }
  }, {
    key: 'handleExitedPopover',
    value: function handleExitedPopover() {
      document.body.removeEventListener('keydown', this.handleKeyDown.bind(this), false);
      this.setState({ isPopoverOpen: false });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var _this3 = this;

      var ENTER = 13;
      var isPopoverOpen = this.state.isPopoverOpen;


      if (isPopoverOpen && event.keyCode === ENTER) {
        event.preventDefault();

        this.setState({
          value: document.getElementById('video_url').value
        }, function () {
          _this3.handleExitPopover();
        });
      }
    }
  }, {
    key: 'handleRemoveVideo',
    value: function handleRemoveVideo() {
      var _props2 = this.props,
          removeOEmbed = _props2.removeOEmbed,
          onRemoveVideo = _props2.onRemoveVideo; // eslint-disable-line no-shadow

      this.setState({ value: null }, function () {
        removeOEmbed();
        onRemoveVideo();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          oembed = _props3.oembed,
          popoverContainer = _props3.popoverContainer,
          error = _props3.error,
          polyglot = _props3.polyglot;


      var boxUI = '';
      if (oembed === null || oembed.html === null) {
        // Empty
        boxUI = _react2.default.createElement(VideoBox.Empty, {
          popoverContainer: popoverContainer,
          polyglot: polyglot,
          handleChange: this.handleChange.bind(this),
          handleEnteredPopover: this.handleEnteredPopover.bind(this),
          handleExitPopover: this.handleExitPopover.bind(this),
          handleExitedPopover: this.handleExitedPopover.bind(this),
          error: error
        });
      } else {
        // HasContent
        boxUI = _react2.default.createElement(VideoBox.HasVideo, { video: oembed, handleRemoveVideo: this.handleRemoveVideo.bind(this) });
      }

      return _react2.default.createElement(
        'span',
        null,
        boxUI
      );
    }
  }], [{
    key: 'Empty',
    value: function Empty(_ref2) {
      var value = _ref2.value,
          error = _ref2.error,
          handleChange = _ref2.handleChange,
          popoverContainer = _ref2.popoverContainer,
          handleExitPopover = _ref2.handleExitPopover,
          handleEnteredPopover = _ref2.handleEnteredPopover,
          handleExitedPopover = _ref2.handleExitedPopover,
          polyglot = _ref2.polyglot;

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          container: popoverContainer,
          onEntered: handleEnteredPopover,
          onExited: handleExitedPopover,
          onExit: handleExitPopover,
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'videoBoxPopover', className: 'video-box-popover' },
            _react2.default.createElement(_components.Input, {
              id: 'video_url',
              type: 'text',
              defaultValue: value,
              placeholder: 'https://',
              label: polyglot.t('events.videoBox.enterAddress'),
              groupClassName: 'group-class',
              labelClassName: 'label-class',
              onChange: handleChange
            }),
            error && _react2.default.createElement(
              'span',
              null,
              polyglot.t('oembed.error.' + error.code)
            )
          )
        },
        _react2.default.createElement(
          'div',
          { className: 'video-box empty dashed-box' },
          _react2.default.createElement('span', { className: 'icon-cg-play left-icon' }),
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.videoBox.video')
          )
        )
      );
    }
  }, {
    key: 'HasVideo',
    value: function HasVideo(_ref3) {
      var video = _ref3.video,
          handleRemoveVideo = _ref3.handleRemoveVideo;

      return _react2.default.createElement(
        'div',
        { className: 'video-box has-video dashed-box' },
        _react2.default.createElement('div', { className: 'video-container', dangerouslySetInnerHTML: { __html: video.html } }),
        _react2.default.createElement(
          'div',
          { className: 'image-toolbar' },
          _react2.default.createElement(
            'span',
            { onClick: handleRemoveVideo },
            _react2.default.createElement('i', { className: 'icon-cg-trashcan' })
          )
        )
      );
    }
  }]);
  return VideoBox;
}(_react.Component), _class2.propTypes = {
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  video_url: _propTypes2.default.string,
  video: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  onRemoveVideo: _propTypes2.default.func,
  oembed: _propTypes2.default.object.isRequired,
  search: _propTypes2.default.func.isRequired,
  removeOEmbed: _propTypes2.default.func.isRequired,
  error: _propTypes2.default.object
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = VideoBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/VideoBox.js
// module id = 2228
// module chunks = 0